import * as z from 'zod';

import { schema } from '.';
import { validaSchema } from './validaSchema';

export const billetSchema = z.object({
  payment: z.optional(
    z.object({
      billetDate: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
    }),
  ),

  user: schema,
  valida: validaSchema,
});

export type BilletSchema = z.infer<typeof billetSchema>;
